import { BFFGateway, DeviceChangeDispatcherType } from "sb-resp-lib"
import { DataProvider, LeaguesRetriever } from "../Typings";
import * as i from "../contracts";
import { observable, IObservableArray, action } from "mobx";
import { RetrieverChooser } from "./RetrieverChooser";

export class Retriever {
    @observable leagues: i.League[];
    leaguesRetriever!: LeaguesRetriever;
    @observable isLoading: boolean;
    private retrieverChooser: RetrieverChooser;
    deviceChangeDispatcherMock?: DeviceChangeDispatcherType;

    constructor(bff: BFFGateway, dataProvider: DataProvider, deviceChangeDispatcherMock?: DeviceChangeDispatcherType) {
        this.leagues = [];
        this.retrieverChooser = new RetrieverChooser(bff, dataProvider, this.updateLeagues);
        this.isLoading = false;
        this.deviceChangeDispatcherMock = deviceChangeDispatcherMock;
    }

    setRegionId(regionId: string) {
        this.leaguesRetriever.setRegionIds(regionId);
    }

    removeRegionId() {
        this.leaguesRetriever.removeRegionId();
    }

    activate() {
        this.clearData();
        this.deviceChangeDispatcherMock && this.deviceChangeDispatcherMock.activate();
    }

    selectRetriever(sportId?: string, leagueIds?: string[]) {
        this.isLoading = true;
        this.leaguesRetriever = this.retrieverChooser.selectRetriever(sportId, leagueIds);
        this.leaguesRetriever.loadData();
    }
    /* istanbul ignore next */
    @action.bound
    updateLeagues(leagues: IObservableArray<i.League>) {
        this.isLoading = false;
        this.leagues = leagues;
    }
    /* istanbul ignore next */
    clearData() {
        this.leagues = observable([]);
    }

    deactivate() {
        this.clearData();
        this.deviceChangeDispatcherMock && this.deviceChangeDispatcherMock.deactivate();
    }
}